export const WALKTHROUGH_COMPLETED_KEY = "walkthrough_completed_v1";
export const WALKTHROUGH_STATE_EVENT = "walkthrough-state-change";

export const CHAT_WALKTHROUGH_SET_WIDTH_EVENT = "walkthrough-set-chat-width";
export const CHAT_WALKTHROUGH_SET_INPUT_EVENT = "walkthrough-set-chat-input";
export const CHAT_WALKTHROUGH_SET_MODE_EVENT = "walkthrough-set-chat-mode";
export const CHAT_WALKTHROUGH_SET_TAGGED_AGENTS_EVENT = "walkthrough-set-chat-tagged-agents";
export const CHAT_WALKTHROUGH_CLEAR_TAGGED_AGENTS_EVENT = "walkthrough-clear-chat-tagged-agents";
export const CHAT_MESSAGE_SENT_EVENT = "ai-chat-message-sent";


const isBrowser = typeof window !== "undefined";

const getUserKey = (): string => {
  if (!isBrowser) return "anonymous";
  try {
    return (
      window.localStorage.getItem("loggedInUserId") ||
      window.localStorage.getItem("userId") ||
      "anonymous"
    );
  } catch {
    return "anonymous";
  }
};

const readMap = (): Record<string, boolean> => {
  if (!isBrowser) return {};
  try {
    const raw = window.localStorage.getItem(WALKTHROUGH_COMPLETED_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeMap = (map: Record<string, boolean>) => {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(WALKTHROUGH_COMPLETED_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
};

export const isWalkthroughCompleted = (): boolean => {
  return readMap()[getUserKey()] === true;
};

export const setWalkthroughCompleted = (completed: boolean) => {
  const map = readMap();
  const key = getUserKey();
  if (completed) {
    map[key] = true;
  } else {
    delete map[key];
  }
  writeMap(map);
};

export const dispatchWalkthroughState = (active: boolean) => {
  if (!isBrowser) return;
  window.dispatchEvent(
    new CustomEvent<{ active: boolean }>(WALKTHROUGH_STATE_EVENT, {
      detail: { active },
    })
  );
};
